import React, { lazy, Suspense } from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';
import SkeletonLoading from 'helpers/loading/skeletonLoading';

const Component = lazy(() => import('components/integration-external-fields'));

const IntegrationExternalFields = (props) => (
  <CWOConfigProvider>
    <Suspense fallback={<SkeletonLoading rows={8} />}>
      <Component {...props} />
    </Suspense>
  </CWOConfigProvider>
);

export default IntegrationExternalFields;
